<template lang="pug">
el-container.main
    .main-header
        .main-breadcrumb
            span.bcb 团队列表
        .main-action
            el-button(type="primary", size="small", @click="show('teamFormVisible')") 创建
    template(v-if="teams.length === 0")
        .main-content
            .block
                span 您尚未创建/加入团队
    template(v-else)
        .main-content
            el-table(v-bind:data="teams" :header-cell-style="tableHeaderColor" max-height="560px")
                el-table-column(prop="team.name", label="团队代号")
                el-table-column(prop="team.displayName", label="展示名")
                el-table-column(prop="teamRole" label="我的角色" width="120" :formatter="displayRoleCNName")
                el-table-column(prop="team.description", label="描述")
                el-table-column(label="操作" width="180")
                    template(slot-scope="scope")
                        el-button(type="text" @click="editTeam(scope.row.team)") 编辑
                        router-link(:to="{ name: 'teamMembers', params: { teamId: scope.row.team.id }}")
                            el-button.rtlink-btn(type="text") 成员详情
                        el-button(type="text" @click="deleteTeam(scope.row.team.id)") 删除
        .main-pager
            el-pagination.page(background, layout='prev, pager, next', :page-count='page.total', :current-page='page.number', @current-change='currentChange')

    CreateEdit(:teamFormVisible="display.teamFormVisible", :editingTeam="editingTeam", :orgname="org.name", @hideTeamForm="hideTeamForm", @refreshTeams="refreshTeams")
</template>

<script>
// @ is an alias to /src
import {
  getUserOrgsAPI,
  listUserTeamsAPI,
  listOrgTeamsAPI,
  createTeamAPI,
  deleteTeamByIDAPI
} from "@/services"
import CreateEdit from "./CreateEdit.vue"

export default {
  name: "Team",
  components: { CreateEdit },
  data() {
    return {
      loading: false,
      page: {
        total: 1,
        number: 1
      },
      org: {},
      teams: [],
      editingTeam: null,
      display: {
        teamFormVisible: false,
        teamMemberFormVisible: false
      }
    }
  },
  methods: {
    /**
         * Backend Service API Function Wrapper
         */
    async getUserOrgs() {
      this.loading = true
      try {
        const res = await getUserOrgsAPI({
          name: localStorage.getItem("account")
        })
        if (res.status === 200 && res.data.length) {
          this.org = Object.assign({}, res.data[0].org)
        }
      } catch {
        console.log(localStorage.getItem("account"))
        this.$message.error("服务器开小差了，请尝试重新操作")
      } finally {
        this.loading = false
      }
    },
    async listUserTeams() {
      this.loading = true
      try {
        const res = await listUserTeamsAPI(
          localStorage.getItem("account"),
          this._.pickBy(this.page, this._.identity)
        )
        if (res.status === 200) {
          this.teams = res.data.data
          this.page = {
            total: res.data.total,
            number: res.data.number
          }
        } else {
          throw err
        }
      } catch (err) {
        console.log(err)
        this.$message.error("服务器开小差了，请尝试重新操作")
      } finally {
        this.loading = false
      }
    },
    async deleteTeam(id) {
      this.loading = true
      try {
        const res = await deleteTeamByIDAPI({ id })
        if (res.status === 204) {
          this.$message("删除成功")
          this.refreshTeams()
        } else {
          throw err
        }
      } catch (err) {
        this.$message.error("服务器开小差了，请尝试重新操作")
      } finally {
        this.loading = false
      }
    },
    // TODO org admin and owner should use this func
    async listOrgTeams() {
      try {
        const res = await listOrgTeamsAPI({ name: this.org.name })
        this.org["teamCount"] = res.data.length
      } catch (err) {
        console.log(err)
      }
    },
    /**
         * UI Control
         */
    show(name) {
      this.display[name] = true
    },
    hide(name) {
      this.display[name] = false
    },
    refreshTeams() {
      this.listUserTeams()
    },
    hideTeamForm() {
      this.hide("teamFormVisible")
      this.editingTeam = null
    },
    hideTeamMemberForm() {
      this.hide("teamMemberFormVisible")
      this.editingTeam = null
    },
    editTeam(team) {
      this.show("teamFormVisible")
      this.editingTeam = team
    },
    editTeamMember(team) {
      this.show("teamMemberFormVisible")
      this.editingTeam = team
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;color: #8493A8;"
      }
    },
    currentChange(number) {
      this.page.number = number
      this.listTeamMembers()
    },
    displayRoleCNName(row) {
      if (row.teamRole === "admin") {
        return "管理员"
      } else if (row.teamRole === "member") {
        return "普通成员"
      } else {
        return row.teamRole
      }
    }
  },
  mounted() {
    this.getUserOrgs()
    this.listUserTeams()
  }
}
</script>
<style lang="stylus" scoped>
.block {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin: 10px;
    padding: 20px;
    border: dashed 1px #bbbbbb;
    border-radius: 15px;

    span {
        margin: auto;
    }

    .el-input {
        width: 360px;
    }
}

.rtlink-btn {
    margin: 0px 10px;
}
</style>
